<template>
  <div class="introducing full-size flex-vertical">
    <img class="introducing-logo" src="../../public/icons/logo.svg" />
    <span class="introducing-header font-bold-32px"
      >Загрузка документов для кандидата</span
    >
    <div class="introducing-main flex-vertical">
      <span class="introducing-main-header font-bold-24px"
        >Ограничение по времени</span
      >
      <span class="introducing-main-content font-regular-16px">
        С момента загрузки первого документа у вас будет {{ expirationMinutes }} минут<br />
        для завершения полного комплекта документов.<br />
        После окончания времени загрузку необходимо повторить.
      </span>
      <span
        v-show="showPersonalDataProcessingError"
        class="personal-data-processing-error font-regular-13px"
        >Необходимо согласие на обработку персональных данных</span
      >
      <div class="personal-data flex font-regular-13px">
        <input type="checkbox" v-model="personalDataProcessingAllowed" />
        <span class="personal-data-processing-text">
          <div @click="personalDataProcessingAllowed = !personalDataProcessingAllowed">
          Соглашаюсь на&nbsp;
          </div>
        </span>
        <a class="personal-data-processing-link" target="_blank" href="non-disclosure-agreement.pdf">
          обработку персональных данных
        </a>
      </div>
      <button class="start-uploading-button" @click="startDocumentsUploading">
        Перейти к загрузке документов
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "IntroducingPage",
  data() {
    return {
      personalDataProcessingAllowed: false,
      showError: false,
    };
  },
  computed: {
    expirationMinutes() {
      return process.env.VUE_APP_EXPIRATION_MINUTES;
    },
    showPersonalDataProcessingError() {
      return this.showError && this.personalDataProcessingAllowed === false;
    },
  },
  methods: {
    startDocumentsUploading() {
      if (this.personalDataProcessingAllowed)
        this.$emit("change-page", "uploading");
      this.showError = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../src/styles/colors.scss";

.introducing {
  background-color: $background-color;
  align-items: center;
}

.introducing-logo {
  position: relative;
  top: 16%;
}

.introducing-header {
  position: relative;
  top: 25%;
  text-align: center;
}

.introducing-main {
  position: relative;
  top: 36%;
  background-color: $white-color;
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  padding: 0px 30px 22px 30px;
  align-items: flex-start;
}

.introducing-main-header {
  margin-top: 25px;
  margin-bottom: 17px;
  letter-spacing: 0px;
  line-height: 32px;
}

.introducing-main-content {
  margin-bottom: 27px;
  letter-spacing: 0px;
  line-height: 24px;
}

.personal-data {
  align-items: center;
  margin-bottom: 4px;
}

.personal-data-processing-error {
  position: absolute;
  top: 155px;
  color: $red-color;
}

.personal-data-processing-text {
  margin-left: 7px;
}

.start-uploading-button {
  width: 100%;
}

@media screen and (max-width: 500px) {
  .introducing-logo {
    top: 10%;
  }

  .introducing-header {
    top: 18%;
    font-size: 20px;
  }

  .introducing-main {
    top: 25%;
    margin: 0px 30px;
    padding: 0px 25px 10px 25px;
  }

  .introducing-main-header {
    font-size: 14px;
    margin-bottom: 2px;
  }

  .introducing-main-content {
    font-size: 13px;
    line-height: 18px;
  }

  .personal-data {
    position: fixed;
    bottom: 115px;
    font-size: 11px;
    left: 32px;
  }

  .personal-data-processing-error {
    position: fixed;
    top: auto;
    bottom: 138px;
    font-size: 11px;
    left: 32px;
  }

  .start-uploading-button {
    position: fixed;
    bottom: 20px;
    width: 90%;
    align-self: center;
  }
}
</style>